import Qs from 'qs'
import service from '@/services/service'
import { APIUser } from '@/models/api/user.model'

const resource = {
    main: 'services',
    module: 'users'
}

export class UsersServices {
    public static getUsers () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getUsersPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getUserById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createUser (params: APIUser) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editUser (params: APIUser) {
        return service.put(`${resource.main}/${resource.module}/${params.userId}`, params)
    }

    public static deleteUser (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static resetPassword (params: { userId: number; password: string }) {
        return service.post(`${resource.main}/${resource.module}/reset-password`, params)
    }

    public static addRoleToUser (userId: number, roles: number[]) {
        return service.post(`${resource.main}/${resource.module}/add-roles`, { userId, roles })
    }

    public static removeRoleToUser (userId: number, roles: number[]) {
        return service.put(`${resource.main}/${resource.module}/delete-roles`, { userId, roles })
    }

    public static addPermissionToUser (userId: number, permissions: number[]) {
        return service.post(`${resource.main}/${resource.module}/add-permissions`, { userId, permissions })
    }

    public static removePermissionToUser (userId: number, permissions: number[]) {
        return service.put(`${resource.main}/${resource.module}/delete-permissions`, { userId, permissions })
    }

    public static getMenuUser (userId: number) {
        return service.post(`${resource.main}/${resource.module}/get-menu-user`, { userId, menuId: 1 })
    }

    public static getUserLogued () {
        return service.get(`${resource.main}/${resource.module}/get-user-logued`)
    }
}
